import WordTypes from './word.types'

const INITIAL_STATE = {
	data: null,
	total: 0,
	page: 1,
}

const WordReducer = (state = INITIAL_STATE, action) => {
	const { type, payload } = action
	switch (type) {
		case WordTypes.GET_WORDS:
			return {
				...state,
				...payload,
			}
		default:
			return state
	}
}

export default WordReducer
